import { ringSegments } from "../lib/setup-progress";

const RING_SIZE = 60;
const RING_CENTRE = RING_SIZE / 2;
const RING_RADIUS = 27;

type Props = { total: number; done: number };

export function SetupProgressRing({ total, done }: Props) {
  const segments = ringSegments(RING_CENTRE, RING_RADIUS, total);
  if (segments.length === 0) return null;

  return (
    <svg
      aria-hidden="true"
      width={RING_SIZE}
      height={RING_SIZE}
      viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
      className="pointer-events-none absolute -inset-1.5"
    >
      {segments.map((path, index) => (
        <path
          key={path}
          d={path}
          fill="none"
          stroke={index < done ? "#f79009" : "rgba(156, 163, 175, 0.55)"}
          strokeWidth={2.5}
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
}
